import { endpoints, host } from '@config/endpoints';
import request from './request';

export const getTotalJobPosts = async (HubIds: string[], ISICCodes?: string[], ISCO2Codes?: string[], Locations?: string[], fromQuarter?: string, toQuarter?: string, isEntryLevel?: boolean) => {
    const { path, method } = endpoints.occupationAndSector.getTotalJobPosts;

    let err = null;
    let res: any = null;

    try {
        ({ data: res } = await request(
            `${host}${path}`,
            method,
            { HubIds, ISICCodes, ISCO2Codes, Locations, fromQuarter, toQuarter, isEntryLevel },
            {},
        ));
    } catch (error) {
        // @ts-ignore
        err = error.message;
    }

    return [err, res];
};
